import { render, staticRenderFns } from "./VisorMaps.vue?vue&type=template&id=36455006&scoped=true"
import script from "./VisorMaps.vue?vue&type=script&lang=js"
export * from "./VisorMaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36455006",
  null
  
)

export default component.exports